import { TableSelect } from "./select";
import { ItemSelectBehavior, TableDefinition } from "./table";

export enum TableAction {
    SET_DATA = "[TableAction] SET_DATA",
    SET_TABLE_DEFINITION = "[TableAction] SET_TABLE_DEFINITION",
    SET_TABLE_HEIGHT = "[TableAction] SET_TABLE_HEIGHT",
    SET_SORT_KEY = "[TableAction] SET_SORT_KEY",
    SET_COLUMN_HEADER_SIZE = "[TableAction] SET_COLUMN_HEADER_SIZE",
    SET_COLUMN_CONTENT_SIZE = "[TableAction] SET_COLUMN_CONTENT_SIZE",
    SET_COLUMN_SHOWN = "[TableAction] SET_COLUMN_SHOWN",
    SET_SELECTED_ITEMS = "[TableAction] SET_SELECTED_ITEMS",
    ADD_SELECTED_ITEM = "[TableAction] ADD_SELECTED_ITEM",
    TOGGLE_SELECT_ALL_ITEMS = "[TableAction] TOGGLE_SELECT_ALL_ITEMS",
}

interface SetData {
    type: TableAction.SET_DATA;
    data: Record<string, any>[];
    indexer: string;
}

interface SetTableDefinition {
    type: TableAction.SET_TABLE_DEFINITION;
    tableDefinition: TableDefinition;
}

interface SetTableHeight {
    type: TableAction.SET_TABLE_HEIGHT;
    tableHeight: number;
}

interface SetSortKey {
    type: TableAction.SET_SORT_KEY;
    sortKey?: string;
    reversed?: boolean;
}

interface SetColumnHeaderSize {
    type: TableAction.SET_COLUMN_HEADER_SIZE;
    accessor: string;
    width: number;
}

interface SetColumnContentSize {
    type: TableAction.SET_COLUMN_CONTENT_SIZE;
    accessor: string;
    width: number;
}

interface SetColumnShown {
    type: TableAction.SET_COLUMN_SHOWN;
    accessor: string;
    isShown: boolean;
}

interface SetSelectedItems {
    type: TableAction.SET_SELECTED_ITEMS;
    selectedItems: TableSelect[];
}

interface AddSelectedItem {
    type: TableAction.ADD_SELECTED_ITEM;
    item: Record<string, any>;
    idx: number;
    itemSelectBehavior: ItemSelectBehavior;
}

interface ToggleSelectAllItems {
    type: TableAction.TOGGLE_SELECT_ALL_ITEMS;
}

export type TableActionTypes =
    | SetData
    | SetTableDefinition
    | SetTableHeight
    | SetSortKey
    | SetColumnHeaderSize
    | SetColumnContentSize
    | SetColumnShown
    | SetSelectedItems
    | AddSelectedItem
    | ToggleSelectAllItems;
